import axios from "axios/index";
import api from "../../config/_api";
import {SYSTEM_ALARM_GPS_UPDATED} from "../actions/system_alarm_gps";

const state = {
    system_alarm_gps: [],
    alarmBySystemId: []
};

const actions = {
    getSysAlarmGps: ({commit, rootGetters}) => {
        //todo rajouter system_id
        axios({url: api.url + 'sysAlarmGps?structure_id=' + rootGetters.structure_id , method: 'GET' })
            .then(resp => {
                commit('SYSTEM_ALARM_GPS_UPDATED', resp.data);
            })
          .catch(err => {
               // console.log("error");
            });
    },
    //recupere une alarme gps sur un system donné
    getSysGps: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
          axios({url: api.url + 'sysAlarmGps?system_id=' + payload.system_id, method: 'GET'})
            .then(resp => {
              commit('SYSTEM_ALARM_GPS_UPDATED', resp.data);
              resolve(resp.data); // résoudre la promesse avec la réponse
            })
            .catch(err => {
              reject(err); // rejeter la promesse avec l'erreur
            });
        });
      },

      update({commit}, payload) {
        const params = new URLSearchParams();
        params.append('longitude', payload.longitude);
        params.append('latitude', payload.latitude);
        params.append('rayon', payload.rayon);
        
        // TODO : Replace structure id by rootGetters.structure_id
        return new Promise((resolve, reject) => {
            axios.put(api.url + 'sysAlarmGps/' + payload.id, params)
            .then((response) => {
                commit('removeSysAlarm', payload.id);
                commit('addSysAlarm', response.data);
                resolve(response.data); // résoudre la promesse avec la réponse
            })
            .catch((error) => {
                reject(error); 
            })
        });
        
    },
    create({commit, rootGetters}, payload) {
        
        const params = new URLSearchParams();
        params.append('longitude', payload.longitude);
        params.append('latitude', payload.latitude);
        params.append('rayon', payload.rayon);
        params.append('system_id', payload.system_id);
        params.append('structure_id', rootGetters.structure_id);

        // TODO : Replace structure id by rootGetters.structure_id
        return new Promise((resolve, reject) => {
            axios.post(api.url + 'sysAlarmGps', params)
            .then((response) => {
                commit('addSysAlarm', response.data);
                commit('removeSysAlarm', -1);
                resolve(response.data); // résoudre la promesse avec la réponse
            })
            .catch((error) => {
                reject(error); 
            })
        });
    },
};

const mutations = {
    [SYSTEM_ALARM_GPS_UPDATED]: (state, system_alarm_gps) => {
        state.system_alarm_gps = system_alarm_gps;
    },
    ['addSysAlarm']: (state, alarm) => {
        state.system_alarm_gps.push(alarm);
    },
    ['removeSysAlarm']: (state, id) => {
        var index = state.system_alarm_gps.findIndex(event => event.id === id);
        state.system_alarm_gps.splice(index, 1);
    },
};


const getters = {
    system_alarm_gps : state => state.system_alarm_gps,
    alarmBySystemId : state => state.alarmBySystemId
};
const defaultPopperProps = {
    arrowPosition: 'start',
    arrowOffsetScaling: 1,
    popperOptions: {
      placement: 'bottom-start',
      positionFixed: true,
      // more options in https://popper.js.org
    },
  }
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    defaultPopperProps,
    getters
};
